export const CustomBlocksType = {
	PRODUCT_RECOMMENDATION: 'product_recommendation',
	PRODUCT_CHECKOUT: 'product_checkout',
	MENU_NAV: 'menu_nav'
};